import { render, staticRenderFns } from "./BetView.vue?vue&type=template&id=4ceb24d6&"
import script from "./BetView.vue?vue&type=script&lang=js&"
export * from "./BetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports